import styled from "styled-components";
import { colors } from "assets/style/Variable";

interface WindDirectionIconProps {
  degree?: string;
  variant?: "chip" | "timeline";
}

export const WindDirectionIcon = ({ degree, variant = "chip" }: WindDirectionIconProps) => {
  const rotate = Number(degree);
  const safeRotate = Number.isNaN(rotate) ? 0 : rotate;
  const timelineRotate = safeRotate + 180;

  return (
    <StyleWindDirectionIcon
      $rotate={variant === "timeline" ? timelineRotate : safeRotate}
      $variant={variant}
      aria-hidden="true">
      <svg viewBox="0 0 24 24" className="arrow" focusable="false">
        <path d="M4 12h11" />
        <path d="m12 7 8 5-8 5 2-5-2-5Z" />
      </svg>
    </StyleWindDirectionIcon>
  );
};

const StyleWindDirectionIcon = styled.span<{ $rotate: number; $variant: "chip" | "timeline" }>`
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:${({ $variant }) => $variant === "timeline" ? "24px" : "14px"};
  height:${({ $variant }) => $variant === "timeline" ? "24px" : "14px"};
  border-radius:${({ $variant }) => $variant === "timeline" ? "0" : "50%"};
  border:${({ $variant }) => $variant === "timeline" ? "none" : "1px solid rgba(106, 103, 229, .28)"};
  .arrow {
    display:block;
    width:${({ $variant }) => $variant === "timeline" ? "20px" : "10px"};
    height:${({ $variant }) => $variant === "timeline" ? "20px" : "10px"};
    stroke:${({ $variant }) => $variant === "timeline" ? colors.blue : colors.mSlateBlue};
    fill:${({ $variant }) => $variant === "timeline" ? colors.blue : colors.mSlateBlue};
    stroke-width:1.6;
    stroke-linecap:round;
    stroke-linejoin:round;
    transform: rotate(${({ $rotate }) => `${$rotate}deg`});
    transform-origin:center;
  }
`;
